/**
 * @namespace layout/flags
 */
import storage from '~/utils/lib/core/storage'
import { clone } from '~/utils/lib/core/prelude'
import { STORE_PREFIX as LAYOUT_STORE_PREFIX } from '~/utils/lib/layout/types'

/** @enum {typeof FEATURES[keyof typeof FEATURES]} */
export const FEATURES = /** @type {const} */ ({
  /// (?) Put your current feature flag here
  ///     eg. `{ FLA_1_DETAILS_PAIE: 'fla_1_details_paie' ... }`
  FLA_1_DETAILS_PAIE: 'fla_1_details_paie',
  FLA_2_AUTRES_ABSENCES: 'fla_2_autres_absences',
  FLA_3_DOCUMENTS_JUSTIFICATIFS: 'fla_3_documents_justificatifs',
  FLA_4_TELETRAVAIL: 'fla_4_teletravail',
  FLA_5_SALARIES: 'fla_5_salaries',
  ENG_399_DISABLE_CHECKS: 'eng_399_disable_checks',
  /// @TODO: remove "paies_bis" features as soon the flag is over
  ///        DONT miss the "components/.../paies-bis" nor the
  ///        "pages/.../paies-bis" nor the "paies-bis" middleware to be removed
  PAIES_BIS: 'paies_bis',
  FLA_8_ACTIONS_REQUISES: 'fla_8_actions_requises',
})

export const useStore_layout_flags = defineStore('layout/flags', {
  state: () => ({
    /** @type {Array<FEATURES>} */
    config: [],
  }),
  actions: {
    /// Mutations
    ///
    setConfig(/** @type {Array<FEATURES>} */ config) {
      this.config = clone(config)

      storage.set(LAYOUT_STORE_PREFIX, 'featureFlags', config)
    },
  }
})
